<div class="flex flex-col gap-2">
  <!-- Parent selector (for features) -->
  @if (requiresParent()) {
    <dojo-single-select
      label="Parent (of)"
      [formCtrl]="getSelectCtrl('parent')"
      [options]="parentOptions()"
      optionLabel="label"
      optionValue="value"
      [size]="'s'"
      (selectionChange)="onParentChange($event)"
    />
  }

  <!-- Dynamic param fields -->
  @if (paramFields().length > 0) {
    <div class="text-[10px] font-semibold uppercase tracking-wider text-neutral-400">Parameters</div>
    <div class="grid grid-cols-2 gap-1.5">
      @for (field of paramFields(); track field.key) {
        @switch (field.type) {
          @case ('number') {
            <dojo-number-input
              [label]="field.label"
              [formCtrl]="getNumberCtrl('param.' + field.key)"
              [step]="0.1"
              [size]="'s'"
            />
          }
          @case ('value-expr') {
            <dojo-text-input
              [label]="field.label"
              [formCtrl]="getTextCtrl('param.' + field.key)"
              [size]="'s'"
              placeholder="number or expression"
            />
          }
          @case ('string') {
            <dojo-text-input [label]="field.label" [formCtrl]="getTextCtrl('param.' + field.key)" [size]="'s'" />
          }
          @case ('port-ref') {
            <dojo-single-select
              [label]="field.label"
              [formCtrl]="getSelectCtrl('param.' + field.key)"
              [options]="portRefOptions()"
              optionLabel="label"
              optionValue="value"
              [size]="'s'"
              placeholder="e.g. t1.edge.AB"
              (selectionChange)="onFieldChange('param.' + field.key, $event)"
            />
          }
          @case ('coord-or-ref') {
            <dojo-text-input
              [label]="field.label"
              [formCtrl]="getTextCtrl('param.' + field.key)"
              [size]="'s'"
              placeholder="coord or ref"
            />
          }
          @case ('tuple-number') {
            <dojo-text-input
              [label]="field.label"
              [formCtrl]="getTextCtrl('param.' + field.key)"
              [size]="'s'"
              placeholder="[2, 2]"
            />
          }
          @case ('select') {
            @if (field.options) {
              <dojo-single-select
                [label]="field.label"
                [formCtrl]="getSelectCtrl('param.' + field.key)"
                [options]="getParamSelectOptions(field)"
                optionLabel="label"
                optionValue="value"
                [size]="'s'"
                (selectionChange)="onFieldChange('param.' + field.key, $event)"
              />
            }
          }
        }
      }
    </div>
  }

  <!-- Polygon vertices (special case) -->
  @if (isPolygonType()) {
    <div class="text-[10px] font-semibold uppercase tracking-wider text-neutral-400">Vertices (JSON)</div>
    <dojo-text-input [formCtrl]="getTextCtrl('polygonVertices')" [size]="'s'" placeholder="JSON array of vertices" />
  }

  <!-- Names -->
  @if (hasNames() && nameFields().length > 0) {
    <div
      class="mt-1 border-t border-neutral-100 pt-2 text-[10px] font-semibold uppercase tracking-wider text-neutral-400"
    >
      Custom Names
    </div>
    <div class="grid grid-cols-2 gap-1.5">
      @for (nf of nameFields(); track nf) {
        <dojo-text-input [label]="nf" [formCtrl]="getTextCtrl('name.' + nf)" [size]="'s'" placeholder="custom name" />
      }
    </div>
  }

  <!-- Display overrides (schema-driven) -->
  @if (styleSections().length > 0 || displayStyleKeys().includes('visible')) {
    <div
      class="mt-1 border-t border-neutral-100 pt-2 text-[10px] font-semibold uppercase tracking-wider text-neutral-400"
    >
      Display
    </div>

    <dojo-style-editor
      [sections]="styleSections()"
      [styleData]="$any(effectiveDisplay())"
      [labelDefaults]="labelDefaults()"
      [visibleDefaults]="visibleDefaults()"
      (styleDataChange)="onStyleEditorChange($event)"
    />
  }

  <!-- Available Ports -->
  @if (portGroups().length > 0) {
    <div class="mt-3 flex flex-col gap-2 border-t border-neutral-100 pt-2">
      @for (group of portGroups(); track group.label) {
        <div>
          <span class="text-[10px] font-semibold uppercase tracking-wider text-neutral-400">{{ group.label }}</span>
          <div class="mt-1 flex flex-wrap gap-1">
            @for (item of group.paths; track item.copyPath) {
              <button
                class="cursor-pointer rounded border border-sky-200 bg-sky-50 px-1.5 py-0.5 font-mono text-[10px] text-sky-600 transition-colors hover:bg-sky-100"
                (click)="copyToClipboard(item.copyPath)"
                [title]="'Click to copy: ' + item.copyPath"
              >
                {{ item.display }}
              </button>
            }
          </div>
        </div>
      }
      <span class="block text-[9px] text-neutral-300">Click to copy</span>
    </div>
  }
</div>
